module.exports = __webpack_public_path__ + "img/QuickEntrance_mr.7dad62f5.svg";